import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {City} from '@models/city';
import {LabelType, Options} from '@angular-slider/ngx-slider';
import {SearchParams, UserSearch, UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {CommonService} from '@services/common.service';
import {CityService} from '@services/city.service';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {environment} from '~/environments/environment';
import * as $ from 'jquery';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {OnboardingService} from '@services/onboarding.service';
import {SEARCH_CITY_PARAMS, SEARCH_PARAMS} from '@models/empty';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';

@Component({
    selector: 'app-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

    searchForm: UntypedFormGroup;
    citiesSearch: City[] = [];
    monthly_min = 0;
    monthly_max = 0;
    types: string[] = [];
    categories: string[] = [];
    estate_sale: string[] = [];
    owner_type: string[] = [];
    rooms: number[] = [];
    floor: string[] = [];
    assets: string[] = [];
    work: string[] = [];
    rent: number[] = [];
    other: string[] = [];
    dpe: number[] = [];
    mode = 'sidebar';

    optionsDiff: Options = {
        floor: -100,
        ceil: 100,
        step: 10,
        translate: (value: number, label: LabelType): string => {
            if (value === 100) {
                return '100% et +';
            } else if (value === -100) {
                return ' - 100% et -';
            }
            return value + ' %';
        }
    };

    optionsCashflow: Options = {
        floor: -1000,
        ceil: 2000,
        step: 10,
        translate: (value: number, label: LabelType): string => {
            if (value === 2000) {
                return '2 000 € et +';
            } else if (value === -1000) {
                return '-1000€ et -';
            }
            return value + ' €';
        }
    };

    optionsPriceChangeEuro: Options = {
        floor: 0,
        ceil: 100000,
        step: 500,
        translate: (value: number, label: LabelType): string => {
            if (value === 100000) {
                return '100 000 € et +';
            }
            return value + ' €';
        }
    };

    optionsPriceChangePercent: Options = {
        floor: 0,
        ceil: 100,
        step: 5,
        translate: (value: number, label: LabelType): string => {
            return value + ' %';
        }
    };

    optionsAmountCopro: Options = {
        floor: 0,
        ceil: 10000,
        step: 100,
        translate: (value: number, label: LabelType): string => {
            if (value === 10000) {
                return '10 000 € et +';
            }
            return value + ' €';
        }
    };

    optionsRendement: Options = {
        floor: 0,
        ceil: 25,
        translate: (value: number, label: LabelType): string => {
            if (value === 25) {
                return '25 % et +';
            }
            return value + ' %';
        }
    };

    optionsMonth: Options = {
        floor: 0,
        ceil: 24,
        translate: (value: number, label: LabelType): string => {
            if (value === 24) {
                return '2 an et +';
            }
            return value + ' mois';
        }
    };

    optionsTensiometre: Options = {
        floor: 0,
        ceil: 8,
        translate: (value: number, label: LabelType): string => {
            if (value === 0) {
                return 'Très facile';
            } else if (value === 1) {
                return 'Moy facile';
            } else if (value === 2) {
                return 'Facile';
            } else if (value === 3) {
                return 'Normal';
            } else if (value === 4) {
                return 'Normal';
            } else if (value === 5) {
                return 'Normal';
            } else if (value === 6) {
                return 'Difficile';
            } else if (value === 7) {
                return 'Moy difficile';
            } else if (value === 8) {
                return 'Très difficile';
            }
            return '';
        }
    };

    optionsSquarePrice: Options = {
        floor: 0,
        ceil: 20000,
        step: 100,
        translate: (value: number, label: LabelType): string => {
            if (value === 20000) {
                return '20000 €/m² et +';
            }
            return value + ' €/m²';
        }
    };

    optionsDistance: Options = {
        floor: 0,
        ceil: 100,
        step: 10,
        translate: (value: number, label: LabelType): string => {
            return value + ' km';
        }
    };

    zipCode: City[] = [];
    cities: City[] = [];
    region: string[];
    departement: string[];
    params;

    currentSearch: UserSearch;
    userSearchs: UserSearch[] = [];
    userSearchsCity: UserSearchCity[] = [];
    currentTab = 'city';
    currentTabLoc = 'city';

    constructor(
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        public commonService: CommonService,
        public cityService: CityService,
        public onboardingService: OnboardingService,
        public dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        private router: Router) {
    }

    ngOnInit(): void {
        // Init the form
        this.setSearchForm();

        // Get all get params
        this.params = {'id': ''};
        this.route.params.subscribe(params => {
            this.params = params;
            // For search by get params, from the website
            this.route.queryParams.subscribe(params => {
                    if (Object.keys(params).length > 0) {
                        this.currentSearch = ({} as UserSearch);
                        this.currentSearch.search_ad_params = SEARCH_PARAMS;
                        if (params.price_min) {
                            this.currentSearch.search_ad_params.price[0] = parseInt(params.price_min, 10);
                        }
                        if (params.price_max) {
                            this.currentSearch.search_ad_params.price[1] = parseInt(params.price_max, 10);
                        }
                        if (params.type) {
                            this.currentSearch.search_ad_params.estate_type = [params.type];
                        }
                        if (params.square_min) {
                            this.currentSearch.search_ad_params.surface[0] = parseInt(params.square_min, 10);
                        }
                        if (params.square_max) {
                            this.currentSearch.search_ad_params.surface[1] = parseInt(params.square_max, 10);
                        }
                        if (params.yield_min) {
                            this.currentSearch.search_ad_params.rendement[0] = parseInt(params.yield_min, 10);
                        }
                        if (params.yield_max) {
                            this.currentSearch.search_ad_params.rendement[1] = parseInt(params.yield_max, 10);
                        }
                        if (params.rooms) {
                            this.currentSearch.search_ad_params.rooms = [];
                            if (Array.isArray(params.rooms)) {
                                params.rooms.forEach(r => {
                                    this.currentSearch.search_ad_params.rooms.push(parseInt(r, 10));
                                });
                            } else {
                                this.currentSearch.search_ad_params.rooms.push(parseInt(params.rooms, 10));
                            }
                        }
                        if (params.estate_sale) {
                            this.currentSearch.search_ad_params.estate_sale = params.estate_sale;
                        }
                        if (params.category) {
                            this.currentSearch.search_ad_params.category = params.category;
                        }
                        if (params.city) {
                            this.http.get<City>(environment.apiUrl + 'app/city/' + params.city).subscribe(c => {
                                c.km = 0;
                                this.currentSearch.search_ad_params.cities = [c];
                                this.setSearchForm();
                                this.search();
                            });
                        } else {
                            this.setSearchForm();
                            this.search();
                        }
                    } else {
                        // No GET params
                        if (this.authenticationService.isLogin) {
                            this.adService.getUserSearch().subscribe(r => {
                                if (this.authenticationService.isAllowed('essentiel')) {
                                    this.userSearchs = r;
                                }
                                this.setSearch();
                                this.loadCities();
                            });

                            this.adService.getUserSearchCity().subscribe(r => {
                                if (this.authenticationService.isAllowed('essentiel')) {
                                    this.userSearchsCity = r;
                                    if (r.length > 0) {
                                        if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.show_save_search_city_search == false) {
                                            this.onboardingService.showSearchCitySaveList();
                                        }
                                    }
                                }
                            });
                        } else {
                            this.setSearch();
                            this.loadCities();
                        }

                        this.onboardingService.listen().subscribe(elem => {
                            // if (elem == 'filters_currentTab_advance') {
                            //     this.currentTab = "advance";
                            // } else if (elem == 'filters_currentTab_city') {
                            //     this.currentTab = "city";
                            // }
                        });
                        if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.search.status == 'not_started') {
                        //    this.onboardingService.startSearch().subscribe();
                        }
                    }
                }
            );
        });
    }

    toogleCurrentTabLoc(currentTabLoc) {
        this.currentTabLoc = currentTabLoc;
        setTimeout(function() {
            $('.citySpinner').hide();
        }, 10);
    }

    setSearch() {
        if (this.params.id !== undefined) {
            if (this.params.id == 'result') {
                this.userService.getCurrentSearch().subscribe(params => {
                    this.currentSearch = params;
                    this.setSearchForm(); // Set values in BDD
                    this.currentSearch.search_ad_params = this.getSearchParams(); // Get all value and default value if missing on DB
                    this.setSearchForm(); // Set again with all fields
                });
            } else if (this.userSearchs.length > 0) {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs.forEach(f => {
                        if (f.id === parseInt(this.params.id, 10)) {
                            this.currentSearch = f;
                            this.setSearchForm(); // Set values in BDD
                            this.currentSearch.search_ad_params = this.getSearchParams(); // Get all value and default value if missing on DB
                            this.setSearchForm(); // Set again with all fields
                        }
                    });
                } else {
                    this.alertService.error('Cette fonctionnalité néccessite un plan supérieur, consultez nos forfaits dans Mon comptes > Nos forfaits');
                }
            }
        }
    }

    setSearchForm() {
        const unlock = this.authenticationService.isAllowed('essentiel');

        this.optionsCashflow.disabled = !unlock;
        this.optionsPriceChangePercent.disabled = !unlock;
        this.optionsPriceChangeEuro.disabled = !unlock;
        this.optionsMonth.disabled = !unlock;
        this.optionsSquarePrice.disabled = !unlock;
        this.optionsDiff.disabled = !unlock;
        this.optionsRendement.disabled = false;
        this.optionsAmountCopro.disabled = !unlock;

        this.searchForm = new UntypedFormGroup({
            search: new UntypedFormControl(this.currentSearch && this.currentSearch.search_ad_params.search != null && this.currentSearch.search_ad_params.search.length ? this.currentSearch.search_ad_params.search : ''),
            price_min: new UntypedFormControl(this.currentSearch && this.currentSearch.search_ad_params.price != null && this.currentSearch.search_ad_params.price[0] ? this.currentSearch.search_ad_params.price[0] : ''),
            price_max: new UntypedFormControl(this.currentSearch && this.currentSearch.search_ad_params.price != null && this.currentSearch.search_ad_params.price[1] ? this.currentSearch.search_ad_params.price[1] : ''),

            surface: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.surface != null && this.currentSearch.search_ad_params.surface.length ? this.currentSearch.search_ad_params.surface : null,
                disabled: false
            }),
            surface_land: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.surface_land != null && this.currentSearch.search_ad_params.surface_land.length ? this.currentSearch.search_ad_params.surface_land : null,
                disabled: false
            }),
            squarePrice: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.squarePrice != null && this.currentSearch.search_ad_params.squarePrice.length ? this.currentSearch.search_ad_params.squarePrice : null,
                disabled: this.optionsSquarePrice.disabled
            }),
            squarePriceDiff: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.squarePriceDiff != null && this.currentSearch.search_ad_params.squarePriceDiff.length ? this.currentSearch.search_ad_params.squarePriceDiff : [-100, 100],
                disabled: this.optionsDiff.disabled
            }),
            month: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.month.length ? this.currentSearch.search_ad_params.month : null,
                disabled: this.optionsMonth.disabled
            }),
            rendement: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.rendement != null && this.currentSearch.search_ad_params.rendement.length ? this.currentSearch.search_ad_params.rendement : null,
                disabled: this.optionsRendement.disabled
            }),
            cashflow: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.cashflow != null && this.currentSearch.search_ad_params.cashflow.length ? this.currentSearch.search_ad_params.cashflow : null,
                disabled: this.optionsCashflow.disabled
            }),
            price_change_euro: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.price_change_euro != null && this.currentSearch.search_ad_params.price_change_euro.length ? this.currentSearch.search_ad_params.price_change_euro : null,
                disabled: this.optionsPriceChangeEuro.disabled
            }),
            price_change_percent: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.price_change_percent != null && this.currentSearch.search_ad_params.price_change_percent.length ? this.currentSearch.search_ad_params.price_change_percent : null,
                disabled: this.optionsPriceChangePercent.disabled
            }),
            search_title: new UntypedFormControl({
                value: this.currentSearch ? this.currentSearch.search_ad_params.search_title : null,
                disabled: !unlock
            }),
            search_city_params_id: new UntypedFormControl({
                value: this.currentSearch ? this.currentSearch.search_ad_params.search_city_params_id : null,
                disabled: !unlock
            }),
            cityControl: new UntypedFormControl({value: null}),
            amount_copro: new UntypedFormControl({
                value: this.currentSearch && this.currentSearch.search_ad_params.amount_copro != null && this.currentSearch.search_ad_params.amount_copro.length ? this.currentSearch.search_ad_params.amount_copro : null,
                disabled: this.optionsAmountCopro.disabled
            }),
        });
        this.types = this.currentSearch && this.currentSearch.search_ad_params.estate_type ? this.currentSearch.search_ad_params.estate_type : [];
        if (this.types.includes('fonds de commerce')) {
            this.toogleType('fonds de commerce');
            this.toogleType('fondsdecommerce');
        }
        this.categories = this.currentSearch && this.currentSearch.search_ad_params.category ? this.currentSearch.search_ad_params.category : [];
        this.estate_sale = this.currentSearch && this.currentSearch.search_ad_params.estate_sale ? this.currentSearch.search_ad_params.estate_sale : [];
        this.owner_type = this.currentSearch && this.currentSearch.search_ad_params.owner_type ? this.currentSearch.search_ad_params.owner_type : [];
        this.rooms = this.currentSearch && this.currentSearch.search_ad_params.rooms ? this.currentSearch.search_ad_params.rooms : [];
        this.floor = this.currentSearch && this.currentSearch.search_ad_params.floor ? this.currentSearch.search_ad_params.floor : [];
        this.assets = this.currentSearch && this.currentSearch.search_ad_params.assets ? this.currentSearch.search_ad_params.assets : [];
        this.rent = this.currentSearch && this.currentSearch.search_ad_params.rent ? this.currentSearch.search_ad_params.rent : [];
        this.work = this.currentSearch && this.currentSearch.search_ad_params.work ? this.currentSearch.search_ad_params.work : [];
        this.other = this.currentSearch && this.currentSearch.search_ad_params.other ? this.currentSearch.search_ad_params.other : [];
        this.dpe = this.currentSearch && this.currentSearch.search_ad_params.dpe ? this.currentSearch.search_ad_params.dpe : [];
        this.cities = this.currentSearch && this.currentSearch.search_ad_params.cities ? this.currentSearch.search_ad_params.cities : [];
        this.departement = this.currentSearch && this.currentSearch.search_ad_params.departement ? this.currentSearch.search_ad_params.departement : [];
        this.region = this.currentSearch && this.currentSearch.search_ad_params.region ? this.currentSearch.search_ad_params.region : [];

        this.searchForm.get('cityControl').valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                switchMap(value => this.cityService.search(this.searchForm.get('cityControl').value, true))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.zipCode = d;
            });

        let fav = this.adService.getEmptyFavorite();
        this.monthly_min = this.calcMonthly(fav, this.searchForm.get('price_min').value);
        this.monthly_max = this.calcMonthly(fav, this.searchForm.get('price_max').value);

        this.searchForm.get('price_min').valueChanges
            .subscribe(value => {
                let fav = this.adService.getEmptyFavorite();
                this.monthly_min = this.calcMonthly(fav, value);
            });

        this.searchForm.get('price_max').valueChanges
            .subscribe(value => {
                let fav = this.adService.getEmptyFavorite();
                this.monthly_max = this.calcMonthly(fav, value);
            });
    }

    unlock() {
        const dialogRef = this.dialog.open(UpgradePlanV2Component, {
            width: '520px',
            data: {visuel: 'assets/upgrade/search.png', plan: 'Essentiel', feature: 'Moteur de recherche'}
        });
    }

    loadCities() {
        const params = this.getSearchParams();

        this.adService.searchCities(params).subscribe(res => {
            this.citiesSearch = res;
        }, error => {
            this.alertService.error('Une erreur est survenue');
            console.log(error);
        });
    }

    getSearchParams(): SearchParams {
        if (this.searchForm.get('surface').value && this.searchForm.get('surface').value.length == 2 && this.searchForm.get('surface').value[1] == 0) {
            this.searchForm.get('surface').value[1] = '';
        }
        if (this.searchForm.get('surface_land').value && this.searchForm.get('surface_land').value.length == 2 && this.searchForm.get('surface_land').value[1] == 0) {
            this.searchForm.get('surface_land').value[1] = '';
        }

        return {
            search: this.searchForm.get('search').value || '',
            sort: '',
            sort_order: '',
            estate_type: this.types,
            category: this.categories,
            estate_sale: this.estate_sale,
            owner_type: this.owner_type,
            rooms: this.rooms,
            floor: this.floor,
            assets: this.assets,
            work: this.work,
            rent: this.rent,
            other: this.other,
            dpe: this.dpe,
            price: [parseInt(this.searchForm.get('price_min').value, 10), parseInt(this.searchForm.get('price_max').value, 10)],
            surface: this.searchForm.get('surface').value || [0,],
            surface_land: this.searchForm.get('surface_land').value || [0,],
            squarePrice: this.searchForm.get('squarePrice').value || [this.optionsSquarePrice.floor, this.optionsSquarePrice.ceil],
            squarePriceDiff: this.searchForm.get('squarePriceDiff').value || [this.optionsDiff.floor, this.optionsDiff.ceil],
            month: this.searchForm.get('month').value || [this.optionsMonth.floor, this.optionsMonth.ceil],
            rendement: this.searchForm.get('rendement').value || [this.optionsRendement.floor, this.optionsRendement.ceil],
            cashflow: this.searchForm.get('cashflow').value || [this.optionsCashflow.floor, this.optionsCashflow.ceil],
            price_change_euro: this.searchForm.get('price_change_euro').value || [this.optionsPriceChangeEuro.floor, this.optionsPriceChangeEuro.ceil],
            price_change_percent: this.searchForm.get('price_change_percent').value || [this.optionsPriceChangePercent.floor, this.optionsPriceChangePercent.ceil],
            search_title: this.searchForm.get('search_title').value || false,
            search_city_params_id: parseInt(this.searchForm.get('search_city_params_id').value) || 0,
            amount_copro: this.searchForm.get('amount_copro').value || [this.optionsAmountCopro.floor, this.optionsAmountCopro.ceil],
            cities: this.cities,
            region: this.region,
            departement: this.departement,
            last: 0,
            hide_view: false,
        };
    }

    addCity(value) {
        value.km = 0;
        if (value.type == 'city') {
            this.cities.push(value);
        } else if (value.type == 'region') {
            this.region.push(value.region);
        } else if (value.type == 'departement') {
            this.departement.push(value.departement);
        }
        this.searchForm.get('cityControl').setValue('');
        this.loadCities();
    }

    removeCity(value) {
        const index = this.cities.indexOf(value, 0);
        if (index > -1) {
            this.cities.splice(index, 1);
        }
        this.loadCities();
    }

    removeDepartement(value) {
        const index = this.departement.indexOf(value, 0);
        if (index > -1) {
            this.departement.splice(index, 1);
        }
        this.loadCities();
    }

    removeRegion(value) {
        const index = this.region.indexOf(value, 0);
        if (index > -1) {
            this.region.splice(index, 1);
        }
        this.loadCities();
    }

    cancel() {
        this.router.navigate(['/app/search/result']);
    }

    search() {
        this.currentSearch.search_ad_params = this.getSearchParams();
        if (this.authenticationService.isLogin) {
            this.onboardingService.endSearch(1, 1);
        }
        if (this.params.id != 'result') {
            this.adService.editUserSearch(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/search', this.params.id]);
            });
        } else {
            this.userService.setCurrentSearch(this.currentSearch);
            this.router.navigate(['/app/search/result']);
        }
    }

    calcMonthly(fav, price) {
        let monthly = 0;
        fav.total_price = price * 1.085;
        if (fav.apport > fav.total_price) {
            fav.apport = fav.total_price;
        }

        // Emprunt total
        fav.loaning = fav.total_price - fav.apport;

        // Mensualite credit
        if (fav.rate === 0) {
            monthly = Math.round(fav.loaning / (fav.duration * 12) + fav.rate_insurance * (fav.loaning / 100) / 12);
        } else {
            monthly = Math.round(
                (fav.loaning * ((fav.rate / 100) / 12)) / (1 - Math.pow(1 + ((fav.rate / 100) / 12), -1 * (fav.duration * 12)))
                + fav.rate_insurance * (fav.loaning / 100) / 12);
        }
        if (monthly < 0) {
            monthly = 0;
        }

        return monthly;
    }

    toogleType(value) {
        if (value == 'commerce-fonddecommerce' && !this.authenticationService.isAllowed('expert')) {
            return;
        }
        if (this.types.includes(value)) {
            if (this.types.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.types.indexOf(value, 0);
            if (index > -1) {
                this.types.splice(index, 1);
            }
            if (value == 'commerce-fonddecommerce') {
                // UnSelect commerce
                if (this.types.includes('commerce')) {
                    this.toogleType('commerce');
                }
                if (this.types.includes('fondsdecommerce')) {
                    this.toogleType('fondsdecommerce');
                }
                /* if (this.types.includes('immeuble avec commerce')) {
                     this.toogleType('immeuble avec commerce');
                 }*/
            }
        } else {
            this.types = this.types.concat([value]);
            if (value == 'commerce-fonddecommerce') {
                // Select commerce
                if (!this.types.includes('commerce')) {
                    this.toogleType('commerce');
                }
                if (!this.types.includes('fondsdecommerce')) {
                    this.toogleType('fondsdecommerce');
                }
                // if (!this.types.includes('immeuble avec commerce')) {
                //     this.toogleType('immeuble avec commerce');
                // }
            }
        }
    }

    toogleCategory(value) {
        if (this.categories.includes(value)) {
            if (this.categories.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.categories.indexOf(value, 0);
            if (index > -1) {
                this.categories.splice(index, 1);
            }
        } else {
            this.categories = this.categories.concat([value]);
        }
    }

    toogleEstateSale(value) {
        if (this.estate_sale.includes(value)) {
            if (this.estate_sale.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.estate_sale.indexOf(value, 0);
            if (index > -1) {
                this.estate_sale.splice(index, 1);
            }
        } else {
            this.estate_sale = this.estate_sale.concat([value]);
        }
    }

    toogleOwnerType(value) {
        if (this.owner_type.includes(value)) {
            if (this.owner_type.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.owner_type.indexOf(value, 0);
            if (index > -1) {
                this.owner_type.splice(index, 1);
            }
        } else {
            this.owner_type = this.owner_type.concat([value]);
        }
    }

    toogleRooms(value) {
        if (this.rooms.includes(value)) {
            if (this.rooms.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.rooms.indexOf(value, 0);
            if (index > -1) {
                this.rooms.splice(index, 1);
            }
        } else {
            this.rooms = this.rooms.concat([value]);
        }
    }

    toogleFloor(value) {
        if (this.floor.includes(value)) {
            if (this.floor.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.floor.indexOf(value, 0);
            if (index > -1) {
                this.floor.splice(index, 1);
            }
        } else {
            this.floor = this.floor.concat([value]);
        }
    }

    toogleAssets(value) {
        if (this.assets.includes(value)) {
            const index = this.assets.indexOf(value, 0);
            if (index > -1) {
                this.assets.splice(index, 1);
            }
        } else {
            this.assets = this.assets.concat([value]);
        }
    }

    toogleWork(value) {
        if (this.work.includes(value)) {
            if (this.work.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.work.indexOf(value, 0);
            if (index > -1) {
                this.work.splice(index, 1);
            }
        } else {
            this.work = this.work.concat([value]);
        }
    }

    toogleRent(value) {
        if (this.rent.includes(value)) {
            if (this.rent.length == 1) {
                this.alertService.error('Merci de séléctionner au moins une option dans la catégorie.');
                return; // Never all unselect
            }
            const index = this.rent.indexOf(value, 0);
            if (index > -1) {
                this.rent.splice(index, 1);
            }
        } else {
            this.rent = this.rent.concat([value]);
        }
    }

    toogleOther(value) {
        if (this.other.includes(value)) {
            const index = this.other.indexOf(value, 0);
            if (index > -1) {
                this.other.splice(index, 1);
            }
        } else {
            this.other = this.other.concat([value]);
        }
    }

    toogleDpe(value) {
        if (this.dpe.includes(value)) {
            const index = this.dpe.indexOf(value, 0);
            if (index > -1) {
                this.dpe.splice(index, 1);
            }
        } else {
            this.dpe = this.dpe.concat([value]);
        }
    }

    filterShow(filter) {
        var min, max = 0;
        if (Array.isArray(filter)) {
            min = parseInt(filter[0], 10);
            max = parseInt(filter[1], 10);
        } else if (this.searchForm.get(filter + '_min') && this.searchForm.get(filter + '_max')) {
            min = parseInt(this.searchForm.get(filter + '_min').value, 10);
            max = parseInt(this.searchForm.get(filter + '_max').value, 10);
        }

        if (min > 0 && max > 0) {
            return 'all';
        } else if (min > 0) {
            return 'min';
        } else if (max > 0) {
            return 'max';
        }
        return '';
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            data: {video: 'search'}
        });
    }

    createSecteur() {
        var currentSearch: UserSearchCity = ({} as UserSearchCity);
        currentSearch.search_city_params = SEARCH_CITY_PARAMS;
        this.userService.setCurrentSearchCity(currentSearch);
        this.router.navigate(['/app/city/result/filters']);
    }
}
